import { render, staticRenderFns } from "./force-update-password.vue?vue&type=template&id=765edfd9&scoped=true&"
import script from "./force-update-password.vue?vue&type=script&lang=js&"
export * from "./force-update-password.vue?vue&type=script&lang=js&"
import style0 from "./force-update-password.vue?vue&type=style&index=0&id=765edfd9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765edfd9",
  null
  
)

export default component.exports